

const editorActions = editorWrapper => {
    let input = editorWrapper.getElementsByTagName('textarea')[0];

    let btns = {
        save: document.querySelector("#js-editor-save"),
        cancel: document.querySelector("#js-editor-cancel"),
        open : document.querySelector('#js-open-text')
    };
    
    const closeWrapper = () => editorWrapper.classList.remove('opened');
    
    const cleanEditor = () => {
        CKEDITOR.instances[editorWrapper.dataset.name].setData('');
    };
    
    const saveInput = () => {
        input.dataset.saved = CKEDITOR.instances[editorWrapper.dataset.name].getData();
    };
    
    const restoreEditor = () => {
        CKEDITOR.instances[editorWrapper.dataset.name].setData(input.dataset.saved);
    };
    
    const methods = {
        open : function(){
           document.querySelector("#js-custom-text").classList.toggle('opened');
           restoreEditor();
        },
        save  : function(){
           closeWrapper();
           saveInput();
        },
        cancel : function(){
            closeWrapper();
            cleanEditor();
        }
    };

    for (let btn in btns){
        (btns.hasOwnProperty(btn) && btns[btn] !== null)
            ? btns[btn].addEventListener('click', methods[btn])
            : console.log(`'${btn}' property of btns object doesn't exit. I could not bind listener to '${btn}' btn`);
    }


};

export default editorActions;


// WEBPACK FOOTER //
// ./components/productDetails/editorActions.js